import React, { useEffect } from 'react'
import CUServiceContainer from '../containers/CUService'
import Nav from '../components/nav/Nav';

const CUService: React.FC= () => {

  useEffect(() => {
    document.title = 'Elite Community CU | CU Services';

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = "Services and Benefits that help over and over again";
    document.head.appendChild(metaDescription);
  }, []);

  return (
    <div>
      <Nav />
      <CUServiceContainer />
    </div>
  )
}

export default CUService